import React, { useEffect, useRef } from "react";
import "./Menu.scss";

// Libraries & Packages
import { useMenuStore } from "utils/state/Store";
import { cubicBezier, motion, useAnimation } from "framer-motion";
import { Link } from "react-router-dom";

// Utils
import Animation from "utils/animation/Animation";
import Navigation from "utils/navigation/Navigation";

function Menu() {
  // State
  const { toggleMenu, setToggleMenu } = useMenuStore();

  // Ref
  const refMenu = useRef(null);

  // Framer Motion
  const controlsMenu = useAnimation();
  const controlsText = useAnimation();

  // Functions
  const handleMenuClick = () => {
    setToggleMenu(!toggleMenu);
    if (toggleMenu) {
      window.scrollTo({
        top: 0,
      });
    }
  };

  useEffect(() => {
    controlsMenu.start({
      transform: toggleMenu ? "rotate(90deg)" : "rotate(45deg)",
      position: toggleMenu ? "fixed" : "absolute",
      borderColor: toggleMenu ? "black" : "white",
      transition: {
        borderColor: { delay: toggleMenu ? 0 : 0.5 },
      },
    });

    controlsText.start({
      opacity: toggleMenu ? 1 : 0,
    });
  }, [toggleMenu, controlsMenu, controlsText]);

  return (
    <div>
      {/* Menu */}
      <div className="menu">
        {/* Menu Box */}
        <motion.div
          className="menu__box"
          onClick={handleMenuClick}
          ref={refMenu}
          animate={controlsMenu}
        ></motion.div>
      </div>
      {/* Menu Panel */}
      <motion.div
        className="menu__panel"
        initial={{ display: toggleMenu ? "flex" : "none" }}
        animate={{
          display: toggleMenu ? "block" : "none",
          transition: { delay: toggleMenu ? 0 : 2 },
        }}
      >
        {/* Menu Items */}
        {Navigation.globalNavigation
          .filter((item) => item.type === "explore" || item.type === "services")
          .map((item, i) => {
            return (
              <motion.div
                key={i}
                className="menu__item"
                initial={{
                  transform: "scaleX(0)",
                }}
                animate={{
                  transform: toggleMenu ? "scaleX(1)" : "scaleX(0)",
                  transformOrigin: "right",
                  transition: {
                    duration: 0.2,
                    delay: i * 0.25,
                    ease: cubicBezier[Animation.getcubicBezier().preset01],
                  },
                }}
              >
                <motion.div className="menu__item__text">
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={controlsText}
                    transition={{
                      duration: toggleMenu ? 2 : 0.25,
                      delay: toggleMenu ? i * 0.25 + 1 : 0,
                    }}
                  >
                    <Link
                      to={item.link}
                      onClick={() => {
                        setToggleMenu();
                      }}
                      style={{ textDecoration: "none" }}
                    >
                      {item.name}
                    </Link>
                  </motion.div>
                </motion.div>
              </motion.div>
            );
          })}
      </motion.div>
    </div>
  );
}

export default Menu;
